import { create } from 'zustand';

interface IHeaderState {
    title: string;
    showBack: boolean;
}

interface IHeaderAction {
    setTitle: (title: string) => void;
    setBackVisibility: (visible: boolean) => void;
    setHeadInfo: (title: string, backButtonVisible: boolean) => void;
}

export const useHeader = create<IHeaderState & IHeaderAction>(set => ({
    title: '',
    showBack: false,

    setTitle: title => void set({ title }),
    setBackVisibility: showBack => void set({ showBack }),
    setHeadInfo: (title, showBack) => void set({ title, showBack }),
}));
